<template>
  <div>
    <component
      v-for="(module, index) in permittedModules"
      :key="index"
      :is="module.type"
      v-bind="getModuleProperties(module.type)"
    ></component>
    <dash-footer></dash-footer>
  </div>
</template>

<script>
export default {
  name: "CompanyDashboard",
  components: {
    MemberNews: () => import("@/modules/MemberNews"),
    MemberCommunications: () => import("@/modules/MemberCommunications"),
    AboutCompany: () => import("@/modules/AboutCompany"),
    Billing: () => import("@/modules/Billing"),
    Members: () => import("@/modules/Members"),
    AwardWinners: () => import("@/modules/AwardWinners"),
    Committees: () => import("@/modules/Committees"),
    DashFooter: () => import("@/modules/DashFooter")
  },
  methods: {
    getModuleProperties: function(name) {
      return this.moduleData[this.camelCase(name)];
    },
    camelCase: function(str) {
      return str.replace(/-([a-z])/g, function(g) {
        return g[1].toUpperCase();
      });
    }
  },
  computed: {
    permittedModules() {
      let allowed = [
        { type: "member-news" },
        { type: "member-communications" },
        { type: "about-company" },
        { type: "members" },
        { type: "awardWinners" },
        { type: "committees" }
      ];

      if (
        this.$store.state.user.contact &&
        (this.$store.state.user.contact.includes("Primary") ||
          this.$store.state.user.contact.includes("Invoicing"))
      ) {
        allowed.splice(3, 0, { type: "billing" });
      }

      return allowed;
    }
  },
  data() {
    return {
      moduleData: {
        memberNews: {
          heading: "Custom Notifications Headline",
          blockquote:
            "Short Teaser Text goes Here to get users to click read more. Do not type all content in this section."
        },
        memberCommunications: {
          message:
            "We periodically send emails about upcoming events, new resources, new Open Forum webinars, and other member news via email. In order to ensure that you receive the latest communications and stay up to date on membership, please add us your contacts.  ",
          emails: ["accounting@greenblue.org", "spcinfo@greenblue.org"]
        },
        awardWinners: {
          data: {
            2019: [
              {
                // imgRef: '',
                title: "Packaging Innovation",
                text: "Coca-Cola's 89-oz Simply Juice Container"
              },
              {
                // imgRef: '',
                title: "Breakthrough Process",
                text: "Envision and ViTA"
              },
              {
                // imgRef: '',
                title: "Outcome of a Partnership",
                text:
                  "PepsiCo, Natureworks, Danimer Scientific, Omya, Berry Plastics…"
              },
              {
                // imgRef: '',
                title: "Outstanding Person",
                text: "Ashely C. Hall, Sustainability Manager, Walmart"
              },
              {
                // imgRef: '',
                title: "Outstanding Person",
                text: "Victor Bell, President, EPI"
              }
            ]
          }
        }
      }
    };
  }
};
</script>

<style lang="scss">
@import "@/styles/views/Dashboard.scss";
</style>
